export default __webpack_public_path__ + "static/media/bhrigesh.9b7c8f61.png";